import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class PartyType extends Component {
    state = {
        PartyTypeList:[],
        PartyTypeValue: null,
        isPartyTypeLoading: true
    };
    componentDidMount(){
        this._getPartyType();
    }
    restPartyTypeFilter() {
        //alert("hi");
        this.setState({
            PartyTypeValue: [],
        })
    }
    _getPartyType(){
        axios.get(config.get('API_URL')+'/filters/get-party-type/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var mList = []
                response.data.map((party_type, index) => {
                    mList.push({value: party_type.party_type, label: party_type.party_type})
                });
                this.setState({
                    PartyTypeList:mList,
                    isPartyTypeLoading: false
                })
            }
        });
    }
    changePartyType(optionSelected){
        let value='';
        let midArray = [];
        if(optionSelected.length<1){
            value = null;
            midArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
            });
        }
        this.props.onSelectPartyType(optionSelected, midArray);
        this.setState({
            PartyTypeValue:optionSelected,
        });

    }
    render() {
        return (

            <ReactMultiSelectCheckboxes name="party_type"
                isMulti
//              components={{ MenuList }}
                value={this.state.PartyTypeValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changePartyType.bind(this)}
                options={this.state.PartyTypeList}
                placeholderButtonLabel="Select [Party Type]"
                isLoading={this.state.isPartyTypeLoading}
            />

        );

    }
}
export default PartyType;